import { createFileRoute } from "@tanstack/react-router";
import { apiQuery, useApiSuspenseQuery } from "@/client/lib/api";
import { ensurePage, pageHead } from "@/client/lib/page";
import { ReciboPrintClient } from "@/client/modules/financeiro/recibo/detalhe/recibo-print-client";

export const Route = createFileRoute("/app/financeiro/recibo/$id")({
  loader: ({ context, params }) =>
    ensurePage(context.queryClient, apiQuery("financeiro", "reciboPage", { id: params.id })),
  head: () => pageHead("Recibo"),
  staleTime: Number.POSITIVE_INFINITY,
  component: ReciboPage,
});

function ReciboPage() {
  const { id } = Route.useParams();
  const { data } = useApiSuspenseQuery("financeiro", "reciboPage", { id });
  return <ReciboPrintClient receipt={data} />;
}
